import locals from "../constants/locals";

const langs = {
    RU: "RU",
    EN: "EN"
}

function readStoredLangUpper() {
    if (typeof window === "undefined" || !window.localStorage) {
        return null;
    }
    const raw = localStorage.getItem("local");
    if (!raw) {
        return null;
    }
    const upper = raw.toUpperCase();
    return upper === langs.RU || upper === langs.EN ? upper : null;
}

function resolveInitialLang() {
    return readStoredLangUpper() || langs.EN;
}

class LangService {
    constructor() {
        const lang = resolveInitialLang();
        this._lang = lang;
        this._map = locals[lang];
    }

    get lang() {
        return this._lang
    }

    set lang(lang) {
        const newLang = (lang || langs.EN).toUpperCase();
        localStorage.setItem("local", newLang)
        this._lang = newLang
        this._map = locals[newLang]
    }

    get map() {
        return locals[this.lang]
    }
}

export default new LangService()
